module.exports = __webpack_public_path__ + "static/media/bg.8ded40ca.svg";